import { Dict } from 'mixpanel-browser';
import { SingularConfig, singularSdk } from 'singular-sdk';
import { CheckoutParams, IdentifyParams } from '../analyticsService.types';
import AnalyticsProvider, { ErrorDict, EventName } from './analyticsProvider';

const SINGULAR_EVENTS: Set<EventName> = new Set([
  EventName.GET_STARTED_VISIT,
  EventName.GET_STARTED_CLICK,
  EventName.LOGIN_SUCCESSFUL,
  EventName.CONNECT_MAILBOX_SUCCESSFUL,
  EventName.PAYWALL_SHOW,
  EventName.PAYWALL_CONFIRM,
  EventName.PAYWALL_DENY,
  EventName.PLANS_SHOW,
  EventName.PLANS_CONFIRM,
  EventName.PLANS_DENY,
  EventName.CHURN_SHOW,
  EventName.CHURN_CONFIRM,
  EventName.CHURN_DENY,
  EventName.CHURN_CLAIM_DISCOUNT,
  EventName.CHECKOUT_CAPTURE,
  EventName.CHECKOUT_COMPLETE,
]);

const isProduction = process.env.REACT_APP_TRIMBOX_ENV === 'production';

export default class SingularAnalyticsProvider implements AnalyticsProvider {
  private initialized = false;

  constructor() {
    if (!isProduction) {
      return;
    }

    try {
      const config = new SingularConfig(
        'currentmediallc_c91a44fc',
        'ebeef0c856f7ae3ff03925a04cfedaea',
        'trimbox-web',
      );
      singularSdk.init(config);
      this.initialized = true;
    } catch (e) {
      console.error('[SingularAnalyticsProvider] Failed to initialize:', e);
    }
  }

  public identify(params: IdentifyParams) {
    if (!this.initialized || !params.user_id) {
      return;
    }

    try {
      singularSdk.login(params.user_id);
    } catch (e) {
      console.error('[SingularAnalyticsProvider] Failed to identify:', e);
    }
  }

  public unidentify() {
    if (!this.initialized) {
      return;
    }

    try {
      singularSdk.logout();
    } catch (e) {
      console.error('[SingularAnalyticsProvider] Failed to logout:', e);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public alias(id: string) {
    //
  }

  public track(name: EventName, props?: Dict) {
    if (!this.initialized || !SINGULAR_EVENTS.has(name)) {
      return;
    }

    try {
      singularSdk.event(name, props);
    } catch (e) {
      console.error('[SingularAnalyticsProvider] Failed to track:', e);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public trackCheckout(checkoutParams: CheckoutParams) {
    //
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public trackError(name: EventName, errorProps: ErrorDict) {
    //
  }
}
